export class VehicleUpdateReq{
    vehicleNum:string
    isAvailable:boolean
    constructor(
        vehicleNum:string,
        isAvailable:boolean
    ){
        this.vehicleNum = vehicleNum
        this.isAvailable = isAvailable
    }
}